module.exports = __webpack_public_path__ + "static/media/RED.caae9c50.png";